/* src/pages/taskslibrary/page-tasks-library.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=page-tasks-library.component-SBBEKTJ5.css.map */
